<template>
  <!-- 检测领域 -->
  <div class="detection" ref="detection" style="width: 100%">
    <!-- 页面头部 -->
    <pageHeader ref="pageHeader" pageStatus="2" />
    <section class="solution_business_services" :class="solutionbusinessservices">
      <div :style="{ width: commonWidth }" :class="commonClass">
        <div :class="['solution_nav','font_regular',font14]">
          <span @click="toindex">首页</span>
          <i class="el-icon-arrow-right"></i>
          <span @click="toservices">业务服务</span>
          <i class="el-icon-arrow-right"></i>
          <span class="current_title">{{ title }}</span>
        </div>
        <div class="solution_classify">
          <span
            v-for="(item, index) in classificationList"
            :key="index"
            :class="[columnId === item.columnId ? 'selectedClassify' : '', font20]"
            @click="changeClassify(item)"
          >
            {{ item.name }}
          </span>
        </div>
        <div class="solution_detail_desc_container" v-if="detailInfo">
          <div class="left_container">
            <img
              :src="$path + detailInfo.image"
              alt=""
              style="width: 100%;"
            />
          </div>
          <div class="right_container">
            <p :class="[font26, 'font_bold']">{{ detailInfo.title }}</p>
            <span :class="[font20, 'font_regular']">{{
              detailInfo.description
            }}</span>
            <div :class="[font18, 'consult_btn']" @click="handleConsult">咨询报价</div>
          </div>
        </div>
        <div class="services_detail" v-if="articleDetail">
          <div :class="['font_regular']" v-html="articleDetail.content"></div>
        </div>
      </div>
    </section>
    <!-- 咨询表单 -->
    <section>
      <consultForm  ref="consultForm" />
    </section>
  </div>
</template>

<script>
export default {
  components: {
    pageHeader: () => import("@/components/header"),
    contentTitle: () => import("@/components/contentTitle"),
    consultForm: () => import("@/components/consult"),
  },
  mounted () {
    const obj = {
        platformType : 0,
        targetPage : ''
        } 
        obj.targetPage =  window.location.href
        if (this.commonClass === 'commonComputer') {
            obj.platformType = 1
        } else {
            obj.platformType = 2
        }
        this.$api.iotHome.loggingData(obj)
            .then((res) => {
            if (res.data.success == true) {
            console.log('数据记录成功');
            }
      })

  },
  computed: {
    commonWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 100 + "%";
        case "sm":
          return 100 + "%";
        case "md":
          return 1200 + "px";
        case "lg":
          return 1200 + "px";
        case "xl":
          return 1200 + "px";
      }
    },
    commonClass() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "commonMobile";
        case "sm":
          return "commonMobile";
        case "md":
          return "commonComputer";
        case "lg":
          return "commonComputer";
        case "xl":
          return "commonComputer";
      }
    },
    solutionbusinessservices(){
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "msolutionbusinessservices";
        case "sm":
          return "msolutionbusinessservices";
        case "md":
          return "pcsolutionbusinessservices";
        case "lg":
          return "pcsolutionbusinessservices";
        case "xl":
          return "pcsolutionbusinessservices";
      }
    },
    font32() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "m32";
        case "sm":
          return "m32";
        case "md":
          return "p32";
        case "lg":
          return "p32";
        case "xl":
          return "p32";
      }
    },
    font26() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "m26";
        case "sm":
          return "m26";
        case "md":
          return "p26";
        case "lg":
          return "p26";
        case "xl":
          return "p26";
      }
    },
    font14(){
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "m14";
        case "sm":
          return "m14";
        case "md":
          return "p14";
        case "lg":
          return "p14";
        case "xl":
          return "p14";
      }
    },
    font18() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "m18";
        case "sm":
          return "m18";
        case "md":
          return "p18";
        case "lg":
          return "p18";
        case "xl":
          return "p18";
      }
    },
    font20(){
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "m20";
        case "sm":
          return "m20";
        case "md":
          return "p20";
        case "lg":
          return "p20";
        case "xl":
          return "p20";
      }
    },
    font40() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "m40";
        case "sm":
          return "m40";
        case "md":
          return "p40";
        case "lg":
          return "p40";
        case "xl":
          return "p40";
      }
    }
  },
  metaInfo() {
    return {
      title: this.pageInfo.metaTitle, // set a title
      meta: [
        {
          name: "keyWords",
          content: this.pageInfo.metaKeywords,
        },
        {
          name: "description",
          content: this.pageInfo.metaDescription,
        },
      ],
    };
  },
  watch:{
    $route(){
      this.initView()
    }
  },
  data() {
    return {
      title: '',
      classificationList: [
      ],
      detailInfo: null,
      articleDetail:null,
      columnId: '',
      activedClassify: 0,
      pageInfo: {
        metaTitle: "",
        metaKeywords: "",
        metaDescription: "",
      }
    };
  },
  created(){
    this.initView()
  },
  methods: {
    initView(){
      
      this.gettabList()
    },
    // 获取业务服务的分类
    gettabList(){
      this.$api.iotHome
        .getServiceList({
            type: 1
        })
        .then((res) => {
            if (res.data.success == true) {
              this.classificationList = res.data.data.map((item)=>{
                return{
                  ...item,
                  columnId: item.id
                }
              })
              this.columnId = this.$route.query.columnId
              this.selectedTab()
            }
        });
    },
    /**
     * 切换三级分类
     */
    changeClassify(data) {
      this.columnId = data.columnId
      this.selectedTab()
    },
    //选中当前tab
    selectedTab(){
      for(let i=0;i<this.classificationList.length;i++){
        if(this.classificationList[i].columnId === this.columnId){
         this.title = this.classificationList[i].name
         this.pageInfo.metaTitle = this.classificationList[i].name + '|国联质检'
          this.getArticleLists(this.classificationList[i])
        }
      }
      if(this.commonWidth === '100%'){
        if(this.columnId == '111807'||this.columnId == '111808'||this.columnId == '111809'||this.columnId == '111805') {
          this.$nextTick(()=>{
          let box = this.$el.querySelector(".solution_classify")
          box.scrollLeft = box.scrollWidth
          })
        }
      }
    },
    getArticleLists(data) {
      this.$api.iotHome
        .getArticleLists({
            columnId: data.columnId,
            rows: 1,
            page: 1,
            siteIds: 0
        })
        .then((res) => {
            if (res.data.success == true) {
              if(res.data.data.rows.length<=0){
                this.detailInfo = null
                this.articleDetail = null
                return
              }
              const data = res.data.data.rows[0]
              this.detailInfo = data
              window.localStorage.setItem("sourceNameForm",'');
              window.localStorage.setItem("sourceNameForm",this.detailInfo.title);
              this.getArticleDetail({
                id: this.detailInfo.id,
                siteId: this.detailInfo.siteId
              })
            }
        });
    },
    getArticleDetail(data) {
      this.$api.iotHome
        .getArticleById({
            id: data.id,
        })
        .then((res) => {
            if (res.data.success == true) {
                this.articleDetail = res.data.data
                this.pageInfo = {
                  metaTitle: this.pageInfo.metaTitle,
                  metaKeywords: data.metaKeywords,
                  metaDescription: data.metaDescription
                }
                var reg = new RegExp('src="', "g");
                this.articleDetail.content = this.articleDetail.content.replace(reg, 'src="' + this.$path);
            }
        });
    },
    // 跳转行业服务
    toservices(){
      if(this.columnId != this.classificationList[0].columnId){
        this.changeClassify({
          columnId: this.classificationList[0].columnId
        })
      }
    },
    // 首页
    toindex(){
      this.$router.push({
        path: "/",
      });
    },
    // 咨询表单
    handleConsult() {
      const consultForm = this.$refs.consultForm
      consultForm.$data.dialogVisible = true
    }
  }
};
</script>
<style lang="scss" scoped>
.commonFull{
  width: 100%;
  height: 100%;
}
.commonComputer {
  margin: 0 auto;
}
.commonMobile {
  padding: 0 14px;
}
.solution_business_services {
  .solution_nav {
    color: #9698a0;
    line-height: 1;
    span {
      cursor: pointer;
      display: inline-block;
    }
    .current_title {
      color: #1e203c;
      cursor: default;
    }
  }
  .solution_classify {
    color: #64686e;
    font-weight: 400;
    border-bottom: 1px solid #eaebee;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    font-family: PingFangSC-Regular;
    text-align: center;
    span {
      display: inline-block;
      cursor: pointer;
    }
    .selectedClassify {
      border-bottom: 2px solid #122266;
      box-sizing: border-box;
      margin-bottom: -1px;
      color: #122266;
      font-family: PingFangSC-Bold;
    }
    span:nth-child(1) {
      margin-left: 0;
    }
  }
  .solution_detail_desc_container {
    overflow: hidden;
    .right_container {
      p {
        font-weight: 500;
        color: #1e203c;
        line-height: 1;
      }
      span {
        font-weight: 400;
        color: #9698a0;
        line-height: 30px;
      }
      .consult_btn {
        text-align: center;
        background: #122266;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
.pcsolutionbusinessservices{
  
  .solution_nav{
     margin: 24px auto 40px;
  }
  .solution_classify {
    span{
      padding: 0 16px 17px;
      margin-left: 28px;
    }
  }
  .solution_detail_desc_container{
    display: flex;
    margin-top: 40px;
    position: relative;
    .left_container {
      width: 41.67%;
    }
    .right_container {
      background: #f5f6f9;
      width: 58.33%;
      padding-left: 4%;
      p {
        margin: 32px 0 24px 0;
        
      }
      .consult_btn {
        position: absolute;
        bottom: 32px;
        width: 200px;
        height: 46px;
        line-height: 46px;
      }
    }
  }
  .services_detail{
    margin: 40px 0 80px;
    div{
      margin-top: 24px;
    }
  }
}
.msolutionbusinessservices {
  
  .solution_nav{
    display: none;
  }
  .solution_classify {
    margin: 20px auto 30px;
    span{
      font-size: 14px!important;
      padding: 0 8px 10px;
    }
  }
  .solution_detail_desc_container{
    margin-top: 20px;
    .left_container {
      width: calc(100vw - 28px);
    }
    .right_container{
      p {
        margin: 20px 0 8px 0;
        border-bottom: 1px solid #eaebee;
        padding-bottom: 15px;
        font-size: 16px!important;
      }
      span{
        font-size: 14px!important;
      }
    }
    .consult_btn {
      width: 100%;
      height: 40px;
      line-height: 40px;
      margin-top: 10px;
      font-size: 15px!important;
    }
  }
  .services_detail{
    margin: 30px 0;
    p:nth-child(1){
      font-size: 20px!important;
      color: #1e203c;
    }
    div{
      margin-top: 12px;
    }
  }
}
</style>
<style lang="scss">
  .pcsolutionbusinessservices{
    .services_detail{
      h1{
        font-size: 22px!important;
        margin-bottom: 20px;
        font-family: PingFangSC-Bold!important;
        span{
          font-size: 22px!important;
          font-family: PingFangSC-Bold!important;
        }
      }
      p{
        font-size: 18px!important;
        line-height: 33px!important;
        span{
          font-size: 18px!important;
          line-height: 33px!important;
        }
        img {
          width: 100%;
        }
      }
    }
  }
  .msolutionbusinessservices{
    .services_detail{
      h1{
        font-size: 16px!important;
        margin-bottom: 10px;
        font-family: PingFangSC-Bold!important;
        span{
          font-size: 16px!important;
          font-family: PingFangSC-Bold!important;
        }
      }
      p{
        font-size: 14px!important;
        line-height: 26px!important;
        span{
          font-size: 14px!important;
          line-height: 26px!important;
        }
        img{
          width: 100% !important;
        }
      }
    }
  }
</style>
